function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, memo } from 'react';
import SlicesItem from './SlicesItem';

class Slices extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderSlice", (slice, index) => {
      const _this$props = this.props,
            tooltip = _this$props.tooltip,
            debug = _this$props.debug,
            axis = _this$props.axis,
            height = _this$props.height,
            setCurrent = _this$props.setCurrent,
            current = _this$props.current;
      const isCurrent = current && current.id === slice.id;
      return React.createElement(SlicesItem, {
        key: slice.id,
        slice: slice,
        axis: axis,
        debug: debug,
        height: height,
        tooltip: tooltip,
        setCurrent: setCurrent,
        isCurrent: isCurrent || false
      });
    });
  }

  render() {
    const slices = this.props.slices;

    if (!slices) {
      return false;
    }

    return React.createElement("g", {
      className: "slices"
    }, slices.map(this.renderSlice));
  }

}

export default memo(Slices);